var exports = {
  "k": "xe533113f--e1fcee--container",
};

module.exports = exports;
